import React, {useMemo, useRef, useState} from 'react'
import {Button, Form} from 'design-react-kit'
import createWrpInput from 'src/frontend/app/components/Form/WrpInput'
import GenericCard from 'src/frontend/app/components/GenericCard'
import GenericInput from 'src/frontend/app/components/Form/Input'
import GenericButton from 'src/frontend/app/components/GenericButton'
import {createFormData, getTabActiveFormId, handleChangeFormData, validateFormData} from 'src/app/utils/form-utils'
import {TableComposable, Tbody, Td, Th, Thead, Tr} from '@patternfly/react-table'
import {Title} from '@patternfly/react-core'
import close from '../../../../images/x.png'
import GenericSelect from 'src/frontend/app/components/Form/Select'
import {useSdaf} from 'src/hooks/useReqOptions'
import formValidationRules from './AltriTitoliFormRules'
import {TIPI_TITOLO_DI_STUDIO} from 'src/formazione'
import {isCurrentMobileDevice} from 'src/utilities/deviceUtility'

const FormAltriTitoli: React.FunctionComponent<GeneralFormAltriTitoli> = ({ title, data, handleInput, onInitInput, errors, viewOnly }) => {
  const refForm = useRef<any>([])
  const [dataForm, setData] = useState<any>({})
  const [errorsForm, setErrors] = useState<any>({})
  const [dirty, setDirty] = useState<boolean>(false)
  const formData = createFormData(dataForm, setData, errorsForm, setErrors)
  const objKey = ''
  const sdaf = useSdaf()

  const columns: Column[] = [
    {
      label: 'Tipo',
      field: 'tipo',
      isSortable: false,
      render: (row) => {
        return row?.tipo?.label
      },
    },
    { label: 'Titolo', field: 'titolo', isSortable: false },
    { label: 'Consecuito da', field: '', isSortable: false },
    {
      label: 'Settore disciplinare',
      field: 'sdaf',
      isSortable: false,
      render: (row) => {
        return row?.sdaf?.cod
      },
    },
    { label: 'Conseguito dal', field: 'conseg_da', isSortable: false },
    { label: 'al', field: 'conseg_a', isSortable: false },
  ]

  const handleInputChange = (code, value) => {
    handleChangeFormData(formData, code, value, formValidationRules)
  }

  const onInit = (cmp, tab) => {
    refForm.current.push({
      cmp: cmp,
      tab: 0,
    })
  }

  const removeFromTitoli = (index) => {
    const datiSlice = [...data?.titoli].filter((elem, indice) => {
      return indice !== index
    })
    handleInput('titoli', datiSlice)
  }

  const getColumnValue = (column: any, row: any) => {
    if (column.field && row[column.field] !== undefined) {
      const value = row[column.field]
      if (column.options && column.options[value]) {
        return column.options[value]
      }
      return row[column.field]
    }
    return ''
  }

  const Spacer = () => (
    <>
      <br></br>
    </>
  )

  const WrpInput = useMemo(() => createWrpInput({ objKey, onInit: onInit, onChange: handleInputChange, viewOnly }), [])

  const aggiungiTitolo = () => {
    const inputs = getTabActiveFormId(refForm, 0)
    const isValid = validateFormData(formData, formValidationRules, inputs)
    if (!isValid) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      return
    }

    handleInputChange('tipo', undefined)
    handleInputChange('sdaf', undefined)

    setData({})
    setDirty(true)
    if (data?.titoli) {
      handleInput('titoli', [...data?.titoli, dataForm])
    } else {
      handleInput('titoli', [dataForm])
    }

    setTimeout(() => {
      setDirty(false)
    }, 100)
  }

  return (
    <GenericCard cardHeader={title}>
      {data?.titoli?.length > 0 && data?.titoli && (
        <>
          <Title headingLevel="h2" size="lg">
            Titoli:
          </Title>
          <Spacer></Spacer>
          <TableComposable aria-label="Sort table">
            <Thead>
              <Tr>
                {columns.map((column, index) => {
                  return !column.hidden ? (
                    <Th key={`head${index}`} style={column.style || {}}>
                      {column.label}
                    </Th>
                  ) : (
                    <></>
                  )
                })}
              </Tr>
            </Thead>
            <Tbody>
              {data?.titoli.map((row, index) => {
                return (
                  <Tr key={`row${index}`}>
                    {columns.map((column, index) => {
                      return !column.hidden ? (
                        <Td key={`col${index}`} style={column.style || {}}>
                          {column.render && column.render(row)}
                          {!column.render && getColumnValue(column, row)}
                        </Td>
                      ) : (
                        <></>
                      )
                    })}
                    {!viewOnly && (
                      <Td>
                        <Button
                          onClick={() => {
                            removeFromTitoli(index)
                          }}
                        >
                          <img src={close} alt="" />
                        </Button>
                      </Td>
                    )}
                  </Tr>
                )
              })}
            </Tbody>
          </TableComposable>
          <Spacer></Spacer>
        </>
      )}
      {!dirty && !viewOnly && (
        <Form>
          <Title headingLevel="h2" size="lg">
            Inserisci un nuovo titolo di studio:
          </Title>
          <div className="row">
            <div className={isCurrentMobileDevice() ? null : 'col-6'}>
              <WrpInput
                as={GenericSelect}
                id={'tipo'}
                placeholder="Seleziona tipo di titolo"
                label="Tipo titolo"
                suffix="*"
                defaultOptions={TIPI_TITOLO_DI_STUDIO}
                data={dataForm}
                errors={errorsForm}
              />
            </div>
            <div className={isCurrentMobileDevice() ? null : 'col-6'}>
              <WrpInput as={GenericInput} type={'text'} id="titolo" label="Titolo" suffix="*" data={dataForm} errors={errorsForm} />
            </div>
          </div>
          <div className="row">
            <div className={isCurrentMobileDevice() ? null : 'col-6'}>
              <WrpInput
                as={GenericSelect}
                id={'sdaf'}
                placeholder="Seleziona settore disciplinare"
                label="Settore disciplinare"
                suffix="*"
                defaultOptions={sdaf}
                data={dataForm}
                errors={errorsForm}
              />
            </div>

            <div className={isCurrentMobileDevice() ? null : 'col-6'}>
              <WrpInput as={GenericInput} id="conseg_da" label="Conseguito da" suffix="*" data={dataForm} errors={errorsForm} type={'date'} />
            </div>
          </div>
          <div className="row">
            <div className={isCurrentMobileDevice() ? null : 'col-6'}>
              <WrpInput as={GenericInput} id="conseg_a" label="Conseguito a" suffix="*" data={dataForm} errors={errorsForm} type={'date'} />
            </div>
          </div>

          <div className="row">
            <GenericButton
              label={'Aggiungi'}
              color={'primary'}
              onClickEvent={(e) => {
                e.preventDefault()
                aggiungiTitolo()
              }}
            />
          </div>
        </Form>
      )}
    </GenericCard>
  )
}

interface GeneralFormAltriTitoli {
  data: any
  errors: any
  title: string
  handleInput?: any
  onInitInput?: any
  viewOnly?: boolean
}

export declare interface Column {
  label: string
  width?: boolean
  style?: any
  hidden?: boolean
  isSortable?: boolean
  field: string
  render?: any
  options?: any
}

export default FormAltriTitoli
